// export const baseUrl = "http://localhost/jazirati/";
// export const baseCmsApiUrl = baseUrl + "cms/api/";
// export const baseImagesUrl = baseUrl + "images/";
export const baseUrl = "https://eifel.ir/application/";
export const baseCmsApiUrl = baseUrl + "cms/api/"
export const baseImagesUrl = baseUrl + "images/"
